import { AuthLayout } from "@/components/src/signin/signin-components/auth-layout.component";
import { supabase } from "@/lib/supabase";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { useState } from "react";
import { Link } from "react-router-dom";

export const PasswordRecoveryPage = () => {
	const [email, setEmail] = useState("");
	const [errorMessage, setErrorMessage] = useState<string | null>(null);
	const [successMessage, setSuccessMessage] = useState<string | null>(null);
	const [loading, setLoading] = useState(false);

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		setLoading(true);
		setErrorMessage(null);
		setSuccessMessage(null);

		const { data, error } = await supabase.auth.resetPasswordForEmail(
			email,
			{
				redirectTo: `${window.location.origin}/set-password`,
			}
		);

		if (error) {
			setErrorMessage("Fehler beim Senden des Links");
		} else {
			setSuccessMessage(
				"Link gesendet. Bitte überprüfen Sie Ihr E-Mail Postfach und folgen Sie dem Link."
			);
		}
		setLoading(false);
	};

	return (
		<AuthLayout
			title="Passwort zurücksetzen"
			subtitle="Geben Sie Ihre E-Mail-Adresse ein, um einen Link zum Zurücksetzen Ihres Passworts zu erhalten."
		>
			<form onSubmit={handleSubmit} className="space-y-4">
				<div className="space-y-2">
					<Label htmlFor="email">E-Mail</Label>
					<Input
						id="email"
						name="email"
						type="email"
						value={email}
						onChange={(e) => setEmail(e.target.value)}
						required
						autoComplete="email"
						autoFocus
						className="h-12"
						aria-label="E-Mail Adresse"
					/>
				</div>

				{errorMessage && (
					<div className="rounded-md bg-red-50 border border-red-200 p-3">
						<p className="text-sm text-red-800">{errorMessage}</p>
					</div>
				)}

				{successMessage && (
					<div className="rounded-md bg-green-50 border border-green-200 p-3">
						<p className="text-sm text-green-800">{successMessage}</p>
					</div>
				)}

				<Button
					type="submit"
					disabled={loading}
					size="lg"
					className="w-full h-12 text-base"
				>
					{loading ? "Wird gesendet..." : "Link senden"}
				</Button>
			</form>

			<div className="mt-6 text-center">
				<Link
					to="/"
					className="text-sm text-gray-600 hover:text-gray-900 hover:underline"
				>
					Zurück zum Login
				</Link>
			</div>
		</AuthLayout>
	);
};
